import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StateModule } from '@spartacus/core';
import { NewsEffects } from './store/effects/index';
import { NEWS_FEATURE } from './store/news-state';
import { metaReducers, reducerProvider, reducerToken } from './store/reducers';

@NgModule({
  imports: [
    CommonModule,
    StateModule,
    StoreModule.forFeature(NEWS_FEATURE, reducerToken, { metaReducers }),
    EffectsModule.forFeature([NewsEffects]),
  ],
  providers: [reducerProvider],
})
export class NewsBaseModule {}
